import AddMachine from './AddMachine';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

export default function AddRoomPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="container mx-auto px-4 py-6 space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight mb-1">
                        {t('roomOverview.addRoomPage.title')}
                    </h1>
                    <p className="text-muted-foreground">
                        {t('roomOverview.addRoomPage.subtitle')}
                    </p>
                </div>
                <Button
                    variant="outline"
                    onClick={() => navigate('/room-overview')}
                >
                    <ArrowLeft className="h-4 w-4" />
                    {t('roomOverview.addRoomPage.backButton')}
                </Button>
            </div>

            <AddMachine />
        </div>
    );
}
